import {
  ApolloClient,
  InMemoryCache,
} from "@apollo/client";

export const client = new ApolloClient({
  uri: process.env.REACT_APP_HASURA_ENPOINT,
  cache: new InMemoryCache()
});
